import React from 'react';

const SideBySide = ({ imgSrc, reverseOrder, children }) => {
	return (
		<div className={`c-content-side-by-side ${reverseOrder ? 'c-content-side-by-side--reverse' : ''}`}>
			<div className="c-content-side-by-side__content">
				{children}
			</div>
			<div className="c-content-side-by-side__img">
				<img className="o-fluid-img" src={imgSrc} alt="" loading="lazy" />
			</div>
		</div>
	);
};

export default SideBySide;
